import { Component, computed, input, output, signal } from '@angular/core';
import { IconDefinition, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { Pet, genders, species } from '../../shared/models/pet.model';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { ImageModule } from 'primeng/image';

@Component({
  selector: 'app-pet-card',
  imports: [
    ImageModule,
    FaIconComponent
  ],
  templateUrl: './pet-card.component.html',
  styleUrl: './pet-card.component.scss'
})
export class PetCardComponent {
  private readonly dayInMs = 1000 * 60 * 60 * 24;

  readonly pet = input.required<Pet>();
  readonly selected = output<Pet>();

  readonly arrowRight: IconDefinition = faChevronRight;
  readonly arrowLeft: IconDefinition = faChevronLeft;

  readonly tags = computed(() => {
    const gender = genders.find((item: { name: string, value: string }) => item.value == this.pet().gender)?.name ?? 'Desconhecido';
    const specie = species.find((item: { name: string, value: string }) => item.value == this.pet().specie)?.name ?? 'Desconhecido';

    let petAge: any;
    const dateDiff = (Date.now() - this.pet().birthdate.getTime()) / this.dayInMs;

    if (dateDiff > 365) {
      petAge = Math.floor(dateDiff / 365);
      petAge = `${petAge} ${petAge != 1 ? 'anos' : 'ano'}`;
    } else if (dateDiff > 30) {
      petAge = Math.floor(dateDiff / 30);
      petAge = `${petAge} ${petAge != 1 ? 'meses' : 'mês'}`;
    } else {
      petAge = Math.floor(dateDiff / 7);
      petAge = `${petAge} ${petAge != 1 ? 'semanas' : 'semana'}`;
    }

    return [
      { name: 'Gênero', value: gender },
      { name: 'Espécie', value: specie },
      { name: 'Idade', value: petAge }
    ]
  });

  readonly photoIndex = signal<number>(0);

  onClick(): void {
    this.selected.emit(this.pet())
  }

  onChangePhoto(position: 1 | -1): void {
    const newIndex = this.photoIndex() + position;
    if (newIndex < 0) {
      this.photoIndex.set(this.pet().files.length - 1);
    } else if (newIndex >= this.pet().files.length) {
      this.photoIndex.set(0);
    } else {
      this.photoIndex.set(newIndex);
    }
  }
}
